module.exports = __webpack_public_path__ + "static/img/229_TO8_1973_og.d10fa82.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/229_TO8_1973_og.jpg
// module id = aj1r
// module chunks = 0